import { graphql } from '@/gql';
import type { GetRidesByDeactivatedPartnerCallersQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { PaginatedRideTypeResponse } from '@/models/ride';

export const getRidesByDeactivatedPartnerCallers = async ({
  to,
  from,
  partnerId,
  pagination,
}: GetRidesByDeactivatedPartnerCallersQueryVariables): Promise<PaginatedRideTypeResponse> => {
  const response = await queryExecute({
    query: graphql(`
      query getRidesByDeactivatedPartnerCallers($to: String!, $from: String!, $partnerId: Float!, $pagination: PaginationInputType!) {
        getRidesByDeactivatedPartnerCallers(to: $to, from: $from, partnerId: $partnerId, pagination: $pagination) {
          count
          rows {
            id
            callerId
            dummyId
            driverId
            partnerId
            carId
            requestId
            scheduledRideId
            riderPhone
            vendor
            rideType
            orderedBy
            orderedById
            startLocation
            startLat
            startLong
            startLocationId
            startZoneId
            startVenueId
            endLocation
            destination
            destinationLat
            destinationLng
            curLat
            curLng
            endLat
            endLong
            endNote
            duration
            durationEstimate
            distance
            map
            gogoMap
            driverName
            driverPhone
            driverPhoto
            driverCarImage
            driverPlate
            driverRating
            driverCancels
            driverTakingLongTime
            driverWaitMoreThan7Mins
            driverJoyRide
            driverCalls
            driverTexts
            driverChanges
            redispatches
            overrideBigCar
            overrideSmallCar
            overrideBannedCar
            overrideBadDriver
            callRiderDriverArriving
            noteToDriver
            status
            timeAccepted
            timeArriving
            timeInProgress
            timeCompleted
            timeReceiptReady
            timeCanceled
            timeCustomerCharged
            timePartnerCharged
            eta
            acceptedEta
            digitPressed
            switchedVendors
            skippedStatus
            wrongStatus
            receiptCall
            costPerMin
            costPerMile
            baseFare
            distanceFee
            timeFee
            normalFare
            bookingFee
            minimumFee
            surgeFactor
            surgeUrl
            surgeId
            subtotal
            totalFare
            gogoCost
            customerCost
            partnerCost
            customerCredits
            customerCreditsRefund
            partnerCredits
            partnerCreditsRefund
            gogoRevenue
            gogoFee
            customerRefund
            partnerRefund
            gogoMins
            customerCostOverride
            customerChargeId
            partnerChargeId
            partnerRefundId
            customerRefundId
            timeCustomerRefunded
            timePartnerRefunded
            timeCustomerCreditsRefunded
            timePartnerCreditsRefunded
            paymentTier
            transactionId
            originalReceipt
            note
            reason
            tip
            rating
            needLoveId
            manualSubsidyAmt
            previousDrivers
            customRiderName
            car
            paidStatus
            minutesToAutoRetryRequest
            destinationTypes
            destinations {
              stops {
                streetAddress
                city
                state
                zip
                lat
                lng
                type
                googlePlaceId
                arrivalTime
                departureTime
                durationMs
              }
            }
            serviceType
            caller {
              firstName
              lastName
            }
            createdAt
            updatedAt
          }
        }
      }
    `),
    fetchPolicy: 'no-cache',
    variables: {
      to,
      from,
      partnerId,
      pagination,
    },
  });

  return response.data.getRidesByDeactivatedPartnerCallers;
};
